import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { applicationsQueryKey } from '@services/applications/queries/useApplication'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ApplicationDetail, ApplicationWrite } from 'types/api'

export function useCreateApplication() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('toast')

  async function createApplication(body: ApplicationWrite) {
    const res = await apiClient.post<ApplicationDetail>(
      `${SNA_PREFIX}applications/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: createApplication,
    onSuccess: async () => {
      toast.success({ message: t('applicationCreated') })
      await queryClient.invalidateQueries({ queryKey: applicationsQueryKey })
    },
    onError
  })
}
